import React, { ChangeEvent, FormEventHandler, useEffect } from 'react';
import { InventoryStockStatus } from '../../@types/inventory';
import { InventoryVariantStatus } from '../../@types/inventory';
import { Accordion, Button } from '../common';
import { Statuses } from '../../constants/inventory';

interface InventoryFilterProps {
  setStockStatus: (value: InventoryStockStatus) => void;
  stockStatus?: string;
  variantStatus?: string | null;
  setVariantStatus: (value: InventoryVariantStatus) => void;
  onSubmit: (e: React.ChangeEvent<HTMLFormElement>) => void;
  onClose: () => void;
  showFilter: boolean;
}

const InventoryFilter: React.FC<InventoryFilterProps> = (props) => {
  const [localStockStatus, setLocalStockStatus] = React.useState<InventoryStockStatus | string>(
    props.stockStatus ? (props.stockStatus as InventoryStockStatus) : '',
  );
  const [localVariantStatus, setLocalVariantStatus] = React.useState<InventoryVariantStatus | string>(
    props.variantStatus ? (props.variantStatus as InventoryVariantStatus) : '',
  );

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const modalContent = document.getElementById('modal-content');

      if (modalContent && !modalContent.contains(event.target as Node)) {
        props.onClose();
      }
    };

    window.addEventListener('mousedown', handleOutsideClick);

    return () => {
      window.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [props]);

  const handleSubmitform = (e:any) => {
    e.preventDefault();
    props.setStockStatus(localStockStatus as InventoryStockStatus);
    props.setVariantStatus(localVariantStatus as InventoryVariantStatus);

    props.onSubmit(e)
  }

  console.log(localStockStatus, localVariantStatus);

  return (
    <div>
      {props.showFilter && (
        <div id="modal-content">
          <form onSubmit={handleSubmitform} className="w-[443px] py-4">
            <Accordion
              items={[
                {
                  title: 'Availability',
                  content: (
                    <>
                      <label htmlFor="in-stock" className="block mb-3">
                        <input
                          type="radio"
                          name="in-stock"
                          id="in-stock"
                          value="in-stock"
                          checked={localStockStatus?.toUpperCase() === Statuses.IN_STOCK.toUpperCase()}
                          onChange={({ target }) => setLocalStockStatus(target.value as InventoryStockStatus)}
                        />
                        <span className="ml-3 inline-block text-gray-900">In Stock</span>
                      </label>
                      <label htmlFor="out-of-stock" className="block mb-3">
                        <input
                          type="radio"
                          name="out-of-stock"
                          id="out-stock"
                          value="out-of-stock"
                          checked={localStockStatus?.toUpperCase() === Statuses.OUT_STOCK.toUpperCase()}
                          onChange={({ target }) => setLocalStockStatus(target.value as InventoryStockStatus)}
                        />
                        <span className="ml-3 inline-block text-gray-900">Out of Stock</span>
                      </label>
                    </>
                  ),
                },
                {
                  title: 'Variation',
                  content: (
                    <>
                      <label htmlFor="has-no-variation" className="block mb-3">
                        <input
                          type="radio"
                          name="has-no-variation"
                          id="has-no-variation"
                          value="has-no-variation"
                          checked={localVariantStatus?.toUpperCase() === Statuses.HAS_NO_VARIATION.toUpperCase()}
                          onChange={({ target }) => setLocalVariantStatus(target.value as InventoryVariantStatus)}
                        />
                        <span className="ml-3 inline-block text-gray-900">No Variations</span>
                      </label>
                      <label htmlFor="has-variation" className="block mb-3">
                        <input
                          type="radio"
                          name="has-variation"
                          id="has-variation"
                          value="has-variation"
                          checked={localVariantStatus?.toUpperCase() === Statuses.HAS_VARIATION.toUpperCase()}
                          onChange={({ target }) => setLocalVariantStatus(target.value as InventoryVariantStatus)}
                        />
                        <span className="ml-3 inline-block text-gray-900">Available Variations</span>
                      </label>
                    </>
                  ),
                },
              ]}
            />
            <div className="my-[20px] justify-center flex ml-[-15em] md:ml-[-17em] xl:ml-[1em]">
              <Button text="Select" size="small" />
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default InventoryFilter;
